import {createStore, applyMiddleware, compose} from "redux";
import rootReducer from "./reducers";
import thunk from "redux-thunk";
import * as Sentry from "@sentry/react";

export default function configureStore(initialState) {
  const sentryReduxEnhancer = Sentry.createReduxEnhancer({});
  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(thunk), sentryReduxEnhancer)
  );
}
